import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormBase } from 'src/app/_models/form-base';

@Component({
    selector: 'app-dropdown-form-field',
    templateUrl: './dropdown-form-field.component.html',
    styleUrls: ['./dropdown-form-field.component.scss'],
    imports: [ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownFormFieldComponent {
  /** Form base (required) */
  field = input<FormBase<string>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Dropdown style: 'default' | 'nav' | 'horizontal' (optional, default: 'default') */
  dropdownStyle = input<'default' | 'nav' | 'horizontal'>('default');
}
